import { createStore } from 'redux';
import reducer from './reducer';

const initialState = {};

export default createStore(reducer, initialState);



// WEBPACK FOOTER //
// ./src/common/store/index.js